import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Injectable()
export class NotificationService {

  constructor(private toastr: ToastrService) {
    toastr.toastrConfig.enableHtml = true;
  }

  public showError = (message: string): void => {
    this.toastr.error(message);
  }

  public showWarning = (message: string): void => {
    this.toastr.warning(message, 'test', {
      timeOut: 10000,
    });
  }

  public showWarningEx = (message: string, title: string, timeOut: number): void => {
    this.toastr.warning(message, title, {
      timeOut: timeOut,
      closeButton: true,
      easing: 'ease-in',
      progressBar: true
    });
  }

  public showInfo = (message: string): void => {
    this.toastr.info(message);
  }
}
